import { render, staticRenderFns } from "./SithMesStoolPrPriceList.vue?vue&type=template&id=48f1b8d6&"
import script from "./SithMesStoolPrPriceList.vue?vue&type=script&lang=js&"
export * from "./SithMesStoolPrPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports